import { withDependencies } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import { DetachApiSymbol, LayoutRuntimeAPISymbol } from './symbols'
import type { IDetachApi, ILayoutRuntimeAPI } from './types'

const viewerManagerRuntimeLayoutApiFactory = (
	detachApi: IDetachApi,
	layoutRuntimeAPI: ILayoutRuntimeAPI
): IViewerManagerImplementor<'runtimeLayout'> => {
	const runtimeLayout = {
		...detachApi,
		...layoutRuntimeAPI,
	}

	return {
		// @ts-expect-error - need to update ds apis types - remove 'updateRuntimeLayout', 'removeRuntimeLayout'
		runtimeLayout,
	}
}

export const ViewerManagerRuntimeLayoutApi = withDependencies(
	[DetachApiSymbol, LayoutRuntimeAPISymbol],
	viewerManagerRuntimeLayoutApiFactory
)
